import { render } from "./SearchConditionPopupStudentSort.vue?vue&type=template&id=ec0ca12e&scoped=true&ts=true"
import script from "./SearchConditionPopupStudentSort.vue?vue&type=script&lang=ts"
export * from "./SearchConditionPopupStudentSort.vue?vue&type=script&lang=ts"

import "./SearchConditionPopupStudentSort.vue?vue&type=style&index=0&id=ec0ca12e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec0ca12e"]])

export default __exports__